import { RouterProvider } from '@tanstack/react-router';
import { Providers } from './app/providers';
import { type AppRouter, router as defaultRouter } from './app/router';

export function App({ router = defaultRouter }: { router?: AppRouter }) {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
